var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Newsletter = (function (Newsletter) {

        Newsletter.Messages = (function (Messages) {

            Messages.Subscribe = function (email, mailparams, mailLists, gender) {
            var data = {
                email: email,
                mailparams: mailparams || {},
                mailLists: mailLists,
                gender: gender
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.Subscribe", data);
        };
        Messages.Subscribe.className = "Vendd.Newsletter.Messages.Subscribe";

        Messages.SubscribeSuccess = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.SubscribeSuccess", response);
        };
        Messages.SubscribeSuccess.className = "Vendd.Newsletter.Messages.SubscribeSuccess";

        Messages.SubscribeFailure = function (response) {
            response.data = JSON.parse(response.data);

            Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.SubscribeFailure", response);
        };
        Messages.SubscribeFailure.className = "Vendd.Newsletter.Messages.SubscribeFailure";

        return Messages;

    })(Newsletter.Messages || {});

        return Newsletter;

    })(Vendd.Newsletter || {});

return Vendd;

})(Vendd || {});